<template lang="pug">
  .b-spec-import(data-testid="import-dialog")
    ._title Импорт спецификации
    ._hint Поддерживаются pdf, xlsx, xls, csv, docx и изображения — от 1 до 10 файлов.
    FileDropzone(inputTestId="import-file-input" @drop="addFiles")
    ._files(v-if="files.length")
      ._file(v-for="(file, i) in files" :key="i" data-testid="import-file")
        span._file-name {{ file.name }}
        button._file-remove(type="button" @click="remove(i)") ×
    textarea._comment(data-testid="import-hint" v-model="comment" placeholder="Уточнение для AI")
    ._buttons
      Btn(blue data-testid="import-submit" :disabled="!files.length || busy" @click="submit") Распознать
      Btn(grey @click="$emit('finish', false)") Отмена
</template>

<script>
import FileDropzone from '@/components/FileDropzone.vue';
import fileApi from '@/api/file';
import { apiRun } from '@/model/apiRun';

/**
 * Окно «Импорт» (ТЗ 6.2, 5.2): файлы (1–10) и уточнение для AI. Файлы уходят общей загрузкой с
 * назначением «спецификация» (ТЗ 9.1), затем создаётся задание распознавания — само задание
 * создаёт страница, ей же принадлежит индикатор. Сгенерировано Claude.
 */
export default {
  name: 'SpecImportPopupWrappable',
  components: { FileDropzone },
  data() {
    return {
      files: [],
      comment: '',
      busy: false,
    };
  },
  methods: {
    addFiles(list) {
      const incoming = Array.from(list ?? []);
      this.files = [...this.files, ...incoming].slice(0, 10);
    },
    remove(index) {
      this.files = this.files.filter((f, i) => i !== index);
    },
    async submit() {
      if (!this.files.length || this.busy) return;
      this.busy = true;
      const uploaded = await apiRun(
        () => this.files.reduce(
          (chain, file) => chain.then((acc) => fileApi.createForSpecification(file)
            .then((result) => [...acc, result.id])),
          Promise.resolve([]),
        ),
        'Не удалось загрузить файлы',
      );
      if (!uploaded) {
        this.busy = false;
        return;
      }
      this.$emit('finish', { fileIds: uploaded, hint: this.comment.trim() || null });
    },
  },
};
</script>

<style scoped lang="scss">
.spec-import {
  width: 560px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 14px;

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__hint {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__files {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__file {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    border-radius: 6px;
    background: #F8F9FC;
    font-size: 13px;
  }

  &__file-name {
    flex-grow: 1;
    word-break: break-all;
  }

  &__file-remove {
    border: none;
    background: none;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
  }

  &__comment {
    box-sizing: border-box;
    width: 100%;
    min-height: 70px;
    padding: 8px 10px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    font: inherit;
    font-size: 13px;
    resize: vertical;
  }

  &__buttons {
    display: flex;
    gap: 12px;
  }
}
</style>
